module.exports = __webpack_public_path__ + "img/table-buildings.22a13525.svg";